import React from 'react';
import BannerSectionStyle5 from '../Section/BannerSection/BannerSectionStyle5';
import Section from '../Section';
import DepartmentSectionStyle3 from '../Section/DepartmentSection/DepartmentSectionStyle3';
import BannerSectionStyle6 from '../Section/BannerSection/BannerSectionStyle6';
import { pageTitle } from '../../helpers/PageTitle';
import { examsData } from '../../data/exams';

export default function Departments() {
  pageTitle('Examens proposés');
  return (
    <>
      <BannerSectionStyle5
        bgUrl="/images/departments/banner_bg.svg"
        imgUrl="/images/departments/banner_img.png"
        title="Examens proposés"
        subTitle="Un plateau technique cardiovasculaire complet, réalisé sur place à l’ICVT pour un diagnostic précis et un suivi personnalisé."
      />
      <Section bottomMd={140} bottomLg={100} bottomXl={60}>
        <DepartmentSectionStyle3 data={examsData} />
      </Section>
      <Section className="cs_footer_margin_0">
        <BannerSectionStyle6
          imgUrl="/images/departments/banner_img_2.png"
          title="Protégez votre cœur dès aujourd’hui."
          subTitle="Prenez rendez-vous dès aujourd’hui pour un bilan cardiovasculaire personnalisé."
        />
      </Section>
    </>
  );
}
